import EnumClass, { build } from '../EnumClass';
import data, { ParagraphStyleId, ParagraphStyleData } from './data';
import * as Translations from './translations';

export class ParagraphStyle extends EnumClass<ParagraphStyleId, ParagraphStyleData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: PARAGRAPH_STYLES,
  getById: getParagraphStyleById,
  marshaller: ParagraphStyleMarshaller,
} = build<ParagraphStyleId, ParagraphStyleData, ParagraphStyle>('ParagraphStyleEnum', data, ParagraphStyle);
